module.exports = __webpack_public_path__ + "static/media/brush_13.6290a70d.png";